import type { PentacodeAPIClient, PentacodeAPIModels } from "@pentacode/rest";

export type CreateTimeLogEventParams = PentacodeAPIModels["CreateTimeLogEventParams"];
export type CreateTimeLogEventQueue = PentacodeAPIModels["CreateTimeLogEventParams"][];

export type createTimeLogEventFunction = PentacodeAPIClient["api"]["createTimeLogEvent"];

export async function processCreateTimeLogEventsQueue(
    queue: CreateTimeLogEventQueue,
    createTimeLogEvent: createTimeLogEventFunction
) {
    while (queue.length) {
        const params = queue[0];

        let replaceId: string | undefined = undefined;

        if (params.action === "startShift" && params.timeEntryId?.startsWith("temp_")) {
            replaceId = params.timeEntryId;
            delete params.timeEntryId;
        }

        try {
            const res = await createTimeLogEvent({}, params);

            if (replaceId) {
                queue.forEach((event) => {
                    if (event.timeEntryId === replaceId) {
                        event.timeEntryId = res.timeEntryId;
                    }
                });
            }

            if (res.status === "rejected" && res.rejectedReason) {
                console.warn("TimeLogEvent rejected:", res.rejectedReason, params);
            }

            queue.shift();
        } catch (e) {
            if (replaceId) {
                params.timeEntryId = replaceId;
            }

            //BAD_REQUEST won't succeed the next time, so we can remove it from the queue
            if (e.status === 400) {
                console.warn("Error while processing create time log event", params);
                queue.shift();
            }

            break;
        }
    }
}
